/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';
import DashboardCardOverlay from '../../../components/DashboardCardOverlay';
import NoDataGraphOverlay from '../../../components/NoDataGraphOverlay';
import api from '../../../config/axios';

type ResponseProps = {
  series: string[],
  data: number[]
}

export default function NonPaidInstallmentGraph() {
  const navigate = useNavigate();
  const [series, setSeries] = useState<string[]>([]);
  const [data, setData] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [token] = useState({ headers: { Authorization: `bearer ${localStorage.getItem('adminToken')}` } });

  async function fetchData() {
    try {
      setLoading(true);
      const response = await api.get<ResponseProps>('/admin/reports/defaultInstallmentsTrending', token);
      setData(response.data.data);
      setSeries(response.data.series);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);
  const obj = {
    series: [
      {
        name: 'Vendas',
        data: [
          {
            x: 'Ouro',
            y: 1292,
          },
          {
            x: 'Prata',
            y: 4432,
          },
          {
            x: 'Bronze',
            y: 5423,
          },
        ],
      },
    ],
    options: {
      plotOptions: {
        bar: {
          columnWidth: '60%',
        },
      },
      colors: ['#00E396'],
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
    },

  };
  return (
    <DashboardCardOverlay loading={loading}>
      <div className="contract-reports-cards position-relative h-100">
        <div className="title-wrapper">
          <div className="">
            <h5 className="title">Inadimplência por Parcela</h5>
          </div>
          <div className="d-flex align-items-center">
            <div className="allow-modifications">
              <button type="button" className="active" onClick={() => navigate('/dashboard/relatorio/parcelas')}>Ver detalhes</button>
            </div>
          </div>
        </div>
        {data.length === 0 && (
          <NoDataGraphOverlay />
        )}

        {data.length !== 0 && (
          <ReactApexChart
            options={{ ...obj.options, grid: { show: false }, xaxis: { categories: series, type: 'category' } }}
            series={[{ name: 'PARCELAS', data }]}
            type="bar"
            height={350}
            toolbar={{ show: false }}
          />
        )}

      </div>
    </DashboardCardOverlay>

  );
}
